export default "__VITE_ASSET__DfJCCe8X__"